import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Receipt, ReceiptDetail } from "../../models/receipt.model";

@Component({
  selector: "ngx-dialog-receipt-detail",
  templateUrl: "dialog-receipt-detail.component.html",
  styleUrls: ["dialog-receipt-detail.component.scss"],
})
export class DialogReceiptDetailComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() receiptDetail?: ReceiptDetail;

  loading = false;
  submitted = false;
  strSearch = "";
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(protected ref: NbDialogRef<DialogReceiptDetailComponent>) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    this.ref.close(this.receiptDetail);
  }

  productQuantityIncrement(value) {
    this.receiptDetail.quantity += value;
    this.summaryReceiptDetail();
  }

  summaryReceiptDetail() {
    this.receiptDetail.price = this.receiptDetail.price
      ? parseFloat(this.receiptDetail.price.toString())
      : 0;

    this.receiptDetail.netAmount =
      this.receiptDetail.quantity * this.receiptDetail.price;

    if (this.receiptDetail.discountPercent != 0) {
      // this.receiptDetail.discountAmount = Math.round(
      //   (this.receiptDetail.netAmount * this.receiptDetail.discountPercent) /
      //     100
      // );
      let numb =
        (this.receiptDetail.netAmount * this.receiptDetail.discountPercent) /
        100;
      this.receiptDetail.discountAmount =
        Math.round((numb + Number.EPSILON) * 100) / 100;
      this.receiptDetail.discountAmount = Math.round(
        this.receiptDetail.discountAmount,
      );
    }

    this.receiptDetail.amount =
      this.receiptDetail.netAmount - this.receiptDetail.discountAmount;
  }

  onInputDiscountAmountChange() {
    this.receiptDetail.discountPercent = this.receiptDetail.discountPercent
      ? parseFloat(this.receiptDetail.discountPercent.toString())
      : 0;
    this.receiptDetail.discountPercent = 0;
    this.summaryReceiptDetail();
  }
}
